/*
 * InviteMember Messages
 *
 * This contains all the text for the InviteMember component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'components.InviteMember';

export default defineMessages({
  email: {
    id: `${scope}.email`,
    defaultMessage: 'Email',
  },
  cancel: {
    id: `${scope}.cancel`,
    defaultMessage: 'Cancel',
  },
  save: {
    id: `${scope}.save`,
    defaultMessage: 'Send Invitation',
  },
});
